import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'step-bar',
    templateUrl: './step-bar.component.html',
    styleUrls: ['./step-bar.component.scss'],
    standalone: true,
    imports:[CommonModule]
})
export class StepBarComponent{

  @Input() passoAtual:number = 1;
  @Output() outPasso = new  EventEmitter<number>();
  @Input({required:true}) quantidadePassos: number ;
  get arrayPassos(): number[] { return Array(this.quantidadePassos).fill(0).map((x, i) => i + 1); };

  constructor(){}

  public setPasso(novoPasso:number){
    this.passoAtual = novoPasso;
    this.outPasso.emit(this.passoAtual);
  }
}
